import { Button, Descriptions } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../common/api";

export default function () {
    const { id } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState({});

    useEffect(() => {
        axiosInstance.get(`employee/${id}/bankAccount`).then(({ data }) => setData(data));
    },[]);

    return (
        <Descriptions
            column={1}
            extra={
                <>
                    <Button type="link" onClick={() => navigate("bankAccount/edit")}>
                        Modifica
                    </Button>
                </>
            }
        >
            <Descriptions.Item label="Intestatario">{data.name}</Descriptions.Item>
            <Descriptions.Item label="IBAN">{data.iban}</Descriptions.Item>
        </Descriptions>
    );
}
